import {connect} from "react-redux";
import {Card, CardBody} from "reactstrap";
import APIForm2 from "../../../../Components/APIForm2";
import {shopsReloadShopStart} from "../../../../actions/Shops";

const Common = ({
    activeShop,
    shopsReloadShopStart
}) => {
    return (
        <Card className="main-card mb-3"
            onKeyDown={(event) => {
                event.stopPropagation();
                event.nativeEvent.stopImmediatePropagation();
        }}>
            <CardBody>
                <APIForm2
                    apiPath='shop/shops'
                    modelId={activeShop.id}
                    schemaPath='setting_common_form_schema'
                    afterSubmitCallback={() => shopsReloadShopStart()}
                />
            </CardBody>
        </Card>
    )
};

const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
});

const mapDispatchToProps = dispatch => ({
    shopsReloadShopStart: () => dispatch(shopsReloadShopStart())
});

export default connect(mapStateToProps, mapDispatchToProps)(Common);